import React from 'react'
import './Footer.css'
import { Link } from 'react-router-dom'
import logo from '../../assets/images/TTS Logo.png'
const Footer = () => {
  return (
    <div className="footer-container">
      <div className='container py-3'>
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-6">
              <h6>INFORMATION</h6>
              <ul className='footer-items'>
                <li> <Link to='/privacy-and-cookie-policy' className='footer-link'>Privacy and Cookie Policy</Link> </li>
                <li><Link to='/advanced-search'  className='footer-link'>Advanced Search</Link></li>
              </ul>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
          <h6>COMPANY</h6>
          <ul className='footer-items'>
                <li> <Link to='/about-us'  className='footer-link'>About Us</Link> </li>
                <li><Link to='/contact-us' className='footer-link'>Contact Us</Link></li>
                <li><Link to='/terms-of-service' className='footer-link'>Term of Service</Link></li>
               
              </ul>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
          <h6>GET IN TOUCH</h6>
          <ul className='footer-items'>
              <li><Link to="/latest-news" className='footer-link'>Latest News</Link></li>  
              <li><Link to='/career' className='footer-link'>Career</Link></li>  
              <li><Link to="/articles" className='footer-link'>Articles</Link></li> 
              <li>
                
                <Link className='footer-icon'><i className="bi bi-instagram"></i></Link>
                <Link className='footer-icon'><i className="bi bi-twitter-x"></i></Link>
                <Link className='footer-icon'><i className="bi bi-facebook"></i></Link>
              </li> 
          </ul>
          </div>
         
        </div>
        <div className="row">
          <div className="col-lg-6 col-md-6">
            <p>Copyright © 2025 Oreus Life Sciences Private Limited</p>
          </div>
          <div className="col-lg-6 col-md-6 text-end">
            <p>Digital Partner  <a href="https://techtorch.solutions/" target="_blank"  rel="noopener noreferrer"><img className='img-fluid' src={logo} alt="" /></a></p>
          </div>
        </div>
      </div>
      </div>
  )
}

export default Footer
